(() => {
  const root = document.documentElement;
  const overlay = document.querySelector('[data-vellum-page-transition]');
  if (!overlay) return;
  if (window.Shopify?.designMode) {
    root.classList.remove('vpt-arriving');
    try {
      sessionStorage.removeItem('vellum-page-transition-arriving');
    } catch (error) {}
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let navigating = false;
  const timers = new Set();

  const schedule = (callback, delay) => {
    const timer = window.setTimeout(() => {
      timers.delete(timer);
      callback();
    }, delay);
    timers.add(timer);
  };

  const clearTimers = () => {
    timers.forEach((timer) => window.clearTimeout(timer));
    timers.clear();
  };

  const reset = () => {
    clearTimers();
    navigating = false;
    root.classList.remove('vpt-running', 'vpt-dimmed', 'vpt-half', 'vpt-brand-visible', 'vpt-full');
  };

  const saveArrivalState = () => {
    try {
      sessionStorage.setItem('vellum-page-transition-arriving', '1');
    } catch (error) {}
  };

  const navigate = (url) => {
    saveArrivalState();
    window.location.assign(url);
  };

  const start = (url) => {
    if (navigating) return;
    navigating = true;
    root.classList.add('vpt-running');
    schedule(reset, 7000);

    if (reducedMotion.matches) {
      requestAnimationFrame(() => root.classList.add('vpt-dimmed', 'vpt-brand-visible'));
      schedule(() => navigate(url), 260);
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => root.classList.add('vpt-dimmed'));
    });
    schedule(() => root.classList.add('vpt-full'), 220);
    schedule(() => root.classList.add('vpt-brand-visible'), 1650);
    schedule(() => navigate(url), 2700);
  };

  const eligibleLink = (event) => {
    if (event.defaultPrevented || event.button !== 0) return null;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return null;

    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.hasAttribute('data-no-page-transition')) return null;
    if (link.target && link.target.toLowerCase() !== '_self') return null;

    const rawHref = link.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:') || rawHref.startsWith('javascript:')) return null;

    const url = new URL(link.href, window.location.href);
    if (!/^https?:$/.test(url.protocol) || url.origin !== window.location.origin) return null;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return null;
    return url.href;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (link?.hasAttribute('data-no-page-transition')) {
      try {
        sessionStorage.setItem('vellum-skip-next-page-transition', '1');
      } catch (error) {}
      return;
    }
    const url = eligibleLink(event);
    if (!url) return;
    event.preventDefault();
    start(url);
  }, true);

  document.addEventListener('submit', (event) => {
    if (event.defaultPrevented || navigating) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.hasAttribute('data-no-page-transition')) return;
    if ((form.method || 'get').toLowerCase() !== 'get' || (form.target && form.target.toLowerCase() !== '_self')) return;

    const url = new URL(form.action || window.location.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    const data = event.submitter ? new FormData(form, event.submitter) : new FormData(form);
    url.search = new URLSearchParams(data).toString();
    event.preventDefault();
    start(url.href);
  }, true);

  const reveal = () => {
    if (!root.classList.contains('vpt-arriving')) return;
    try {
      sessionStorage.removeItem('vellum-page-transition-arriving');
    } catch (error) {}
    requestAnimationFrame(() => {
      requestAnimationFrame(() => root.classList.add('vpt-reveal'));
    });
    schedule(() => root.classList.remove('vpt-arriving', 'vpt-reveal'), 490);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal, { once: true });
  } else {
    reveal();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      root.classList.remove('vpt-arriving', 'vpt-reveal');
      reset();
    }
  });

  window.addEventListener('pagehide', clearTimers);
})();
